import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../config";

export default function SeriesDetail() {
  const { seriesId } = useParams();
  const [series, setSeries] = useState(null);
  const [current, setCurrent] = useState(null);

  useEffect(() => {
    fetch("/videos.manifest.json")
      .then((r) => r.json())
      .then((data) => {
        const s = data.series.find((x) => x.id === seriesId);
        setSeries(s || null);
        if (s?.sessions?.[0]?.videos?.[0]) {
          setCurrent(s.sessions[0].videos[0]);
        }
      })
      .catch(console.error);
  }, [seriesId]);

  const logView = async (videoId) => {
    try {
      await axios.post(
        `${API_URL}/log-view`,
        { videoId },
        { withCredentials: true }
      );
    } catch (err) {
      console.error("Failed to log view", err);
    }
  };

  if (!series) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <p className="text-gray-600">Loading…</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <Link
          to="/CMDashboard"
          className="inline-block mb-6 text-blue-600 hover:text-blue-800 font-medium"
        >
          ← Back to all series
        </Link>

        <h1 className="text-4xl font-bold text-gray-900 sm:text-5xl mb-3">
          {series.title}
        </h1>
        <p className="text-lg text-gray-600 mb-10">{series.description}</p>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
          {/* Video Player */}
          <div className="lg:col-span-2 bg-white rounded-2xl shadow-lg p-6">
            <h3 className="text-xl font-semibold text-gray-900 mb-4">
              {current?.title || "Select a video"}
            </h3>
            {current && (
              <video
                src={current.src}
                controls
                controlsList="nodownload"
                className="w-full aspect-video rounded-lg bg-black"
                onPlay={() => logView(current.id)} // ✅ logs view
              />
            )}
          </div>

          {/* Sidebar list */}
          <div className="space-y-6">
            {series.sessions.map((sess) => (
              <div
                key={sess.id}
                className="bg-white rounded-2xl shadow-md overflow-hidden"
              >
                <div className="px-4 py-3 bg-gray-100 font-semibold text-gray-800">
                  {sess.title}
                </div>
                <ul className="divide-y divide-gray-200">
                  {sess.videos.map((v) => (
                    <li key={v.id}>
                      <button
                        onClick={() => setCurrent(v)}
                        className={`w-full text-left px-4 py-3 text-sm font-medium transition-colors duration-200 ${
                          current?.id === v.id
                            ? "bg-blue-50 text-blue-700"
                            : "text-gray-700 hover:bg-gray-50"
                        }`}
                      >
                        ▶ {v.title}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
